import '../../scss/acf-blocks/block-integration-forms.scss';
import { detectOs } from '../components/detect-os';
import initCountryStateSelect from '../components/country-state-select';
import {
    initFormValidation,
    initializeCaptcha,
    showSubmitError,
    recaptchaSiteVerify,
} from '../components/form-validation';

const initIntegrationForms = () => {
    //initializeCaptcha();

    const buttons = document.querySelectorAll("input[name='platform']");
    buttons &&
        buttons.forEach((btn) => {
            if (btn.dataset.platform === detectOs()) {
                btn.setAttribute('checked', 'checked');
            }
        });

    const userPlatform = document.querySelectorAll(
        "input[name='user_platform']"
    );
    userPlatform &&
        userPlatform.forEach((btn) => {
            if (btn.dataset.platform === detectOs()) {
                btn.setAttribute('checked', 'checked');
            }
        });
    const submitButton = document.querySelector('.js-form-submit');
    submitButton &&
        submitButton.addEventListener('click', async (e) => {
            const form = document.querySelector('.js-form');
            const recaptchaResponse =
                document.getElementById('recaptcha-response');

            // Show loader
            const loader = document.querySelector('.js-form-loader');
            loader && loader.classList.add('show');

            let formIsValid = initFormValidation(form);
            const input = document.querySelector('.js-csname');


            // Check if the input exists and is not empty
            if (input && input.value.trim() !== '') {
                formIsValid = false; // Exists and is not empty
            }            
            
            if (formIsValid) {
                try {
                    const token = await grecaptcha.execute(var_from_php.recaptcha_site_key, { action: 'submit' });
                                
                    const result = await recaptchaSiteVerify(token);
            
                    if (result === true) {
                        form.submit();
                    } else {
                        loader && loader.classList.remove('show');
                        console.error('Verification failed.');
                        showSubmitError('Verification failed. Please try again');
                    }
                } catch (error) {
                    showSubmitError(error);
                    loader && loader.classList.remove('show');
                }
            } else {
                loader && loader.classList.remove('show');
                //initializeCaptcha();
            }
        });
    
    // Initializes the country and state/province select elements and adds an event listener for changes.
    initCountryStateSelect();
};

document.defaultView.addEventListener(
    'DOMContentLoaded',
    initIntegrationForms,
    false
);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', initIntegrationForms);
}
